export enum ControlErrorsScope {
  FirstOnly,
  All,
}
